import { useState, useMemo } from 'react';
import {
    Table
} from 'antd';

const TabulatedReport = (
    {
        reportJSON,
        selectedTable,
        dataSrc,
        loading
    }
) => {

    const [ current, setCurrent ] = useState(1)
    const [ pageSize, setPageSize ] = useState(10)
    
    const sortedData = useMemo(
        () => [...(dataSrc || [])].sort((a, b) => b.generatedAt - a.generatedAt),
        [dataSrc]
    );

    const columns = reportJSON[selectedTable].columns?.filter((c) => !c.isHidden);

    return (
        <>
            <Table
                columns={columns}
                dataSource={sortedData}   
                loading={loading}
                rowKey={(record) => record.id ?? record.key} 
                scroll={{ x: columns ? columns.length * 200 : undefined }}
                pagination={{
                    current,
                    pageSize,
                    total: sortedData.length,
                    showSizeChanger: true,
                    onChange: (page, size) => {
                        setCurrent(page);
                        setPageSize(size);
                    },
                }}
                onChange={(paginationInfo) => {
                    if (paginationInfo.current !== current) setCurrent(paginationInfo.current);
                }}
            />
        </>
    )
}

export default TabulatedReport;